const utils = {
  isDefined: <T>(argument: T | undefined | null): argument is T => {
    return argument !== undefined && argument !== null;
  },

  handleClickBubble: (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
  },

  handleClickCapture: (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
  },

  handleClickBubbleAndCapture: (e: React.MouseEvent<HTMLElement>) => {
    utils.handleClickBubble(e);
    utils.handleClickCapture(e);
  },

  getParameterObject: ({url}: {url: string}) => {
    const params = url.split("?")[1]?.split("&") || [];
    const obj: {[key: string]: string} = {};

    for (let i = 0; i < params.length; i++) {
      const temp = params[i]?.split("=") || [];
      const key = temp[0];
      const value = temp.splice(1, temp.length).join("=");
      obj[key] = value;
    }
    return obj;
  },

  getParameter: ({url, key}: {url: string; key: string}) => {
    const obj = utils.getParameterObject({url});
    return obj[key];
  },

  getRandomTxt: ({length = 4}: {length?: number} = {}) => {
    try {
      const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercase = "abcdefghijklmnopqrstuvwxyz";
      const digits = "0123456789";
      const allChars = uppercase + lowercase + digits;

      if (length < 2) {
        throw new Error(
          "Length must be at least 2 to include both uppercase and lowercase letters.",
        );
      }

      let randomText = "";
      randomText += uppercase[Math.floor(Math.random() * uppercase.length)];
      randomText += lowercase[Math.floor(Math.random() * lowercase.length)];

      for (let i = 2; i < length; i++) {
        randomText += allChars[Math.floor(Math.random() * allChars.length)];
      }

      return randomText
        .split("")
        .sort(() => Math.random() - 0.5)
        .join("");
    } catch (error) {
      return "Apb7";
    }
  },

  strReplaceJustNumber: (str?: string) => {
    const isMinus = /^-/.test(str || "");
    const numStr = `${isMinus ? "-" : ""}${(str || "").replace(/[^0-9]/g, "")}`;
    return numStr;
  },

  moveArrayValue: <T>({
    array,
    fromIndex,
    toIndex,
  }: {
    array: T[];
    fromIndex: number;
    toIndex: number;
  }) => {
    const newArray = [...array];
    const item = newArray.splice(fromIndex, 1)[0];
    newArray.splice(toIndex, 0, item);
    return newArray;
  },

  numberFormatting: (value: string | number | undefined) => {
    if (typeof value === "number") {
      return value.toLocaleString();
    } else if (typeof value === "string") {
      if (isNaN(Number(value))) {
        return value;
      } else {
        return Number(value).toLocaleString();
      }
    } else {
      return "";
    }
  },
};

export default utils;
